// extracted by mini-css-extract-plugin
export default {"article":"uo3aAEpy_eJqlP3wJWdD"};